<template>
  <div id="hrese2e">
    Online Test
  </div>
</template>

<script>
import { router } from 'src/router'

export default {
  name: 'hrese2e',
  data () {
    return {
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    window.open('/etest')
    router.push({ name: 'home' })
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?b7e8568e